import { render, staticRenderFns } from "./EmailBroadcast.vue?vue&type=template&id=13a4068d"
import script from "./EmailBroadcast.vue?vue&type=script&lang=js"
export * from "./EmailBroadcast.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcast.vue?vue&type=style&index=0&id=13a4068d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports